<form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit()">
  <div class="input-container">
    <label>Email Address</label>
    <mat-form-field appearance="outline">
      <input matInput formControlName="email" />
      <mat-error class="error" *ngIf="errorHandling('email', 'required')">
        Email is <strong>Required</strong>
      </mat-error>
      <mat-error class="error" *ngIf="errorHandling('email', 'email')">
        Please enter a valid email address
      </mat-error>
    </mat-form-field>
  </div>
  <div class="login-error">{{ errorMsg }}</div>
  <br />
  <br />
  <button mat-flat-button color="accent">
    Send Email
  </button>
</form>
